<template>
  <q-page ref="form">
    <div class="row">
      <div class="col-12 q-pb-md">
        <q-card>
          <q-card-section>
            <div class="row items-center justify-between">
              <div style="display: inline-block" class="text-h6">Club Info</div>
              <q-btn
                v-if="currentUserData.role == 'Club Admin'"
                class="q-ml-md"
                color="primary"
                text-color="white"
                no-caps
                @click="save"
              >
                <q-icon
                  name="mdi-content-save"
                  color="white"
                  class="q-mr-sm"
                  size="xs"
                ></q-icon>
                Save
              </q-btn>
            </div>
          </q-card-section>

          <q-separator />
          <q-card-section class="q-pa-none" v-if="formData">
            <div v-if="gridData">
              <div class="row">
                <!-- <div class="col-12 my-0 py-0 pl-6">
                  *Double click row to open
                </div> -->
                <div class="col-12 q-pa-md">
                  <div class="col-12" :class="{ 'col-md-8': formData.id }">
                    <div class="row">
                      <div class="col-12 col-md-6 q-pa-xs">
                        <q-input
                          v-model="formData.association_name"
                          label="Association Name"
                          readonly
                          v-bind="siteCFG.fields.general"
                        >
                        </q-input>
                      </div>
                      <div class="col-12 col-md-6 q-pa-xs">
                        <q-input
                          label="Abbr"
                          :readonly="currentUserData.role != 'Club Admin'"
                          v-model="formData.association_abbr"
                          v-bind="siteCFG.fields.general"
                        >
                        </q-input>
                      </div>
                      <div class="col-12 col-md-6 q-pa-xs">
                        <q-input
                          v-model="formData.email"
                          :readonly="currentUserData.role != 'Club Admin'"
                          label="Email"
                          v-bind="siteCFG.fields.general"
                        >
                          <template v-slot:prepend>
                            <q-icon name="mdi-email" />
                          </template>
                        </q-input>
                      </div>
                      <div class="col-12 col-md-6 q-pa-xs">
                        <q-input
                          v-model="formData.website"
                          :readonly="currentUserData.role != 'Club Admin'"
                          label="Website"
                          v-bind="siteCFG.fields.general"
                        >
                          <template v-slot:prepend>
                            <q-icon name="mdi-earth" />
                          </template>
                        </q-input>
                      </div>
                      <div class="col-12 col-md-6 q-pa-xs">
                        <q-input
                          :readonly="currentUserData.role != 'Club Admin'"
                          v-model="formData.phone"
                          label="Phone"
                          v-bind="siteCFG.fields.general"
                        >
                          <template v-slot:prepend>
                            <q-icon name="mdi-phone" />
                          </template>
                        </q-input>
                      </div>
                      <div class="col-12 col-sm-6 col-md-3 q-pa-xs">
                        <q-input
                          :readonly="currentUserData.role != 'Club Admin'"
                          v-model="formData.lat"
                          label="Lat"
                          v-bind="siteCFG.fields.general"
                        >
                        </q-input>
                      </div>
                      <div class="col-12 col-sm-6 col-md-3 q-pa-xs">
                        <q-input
                          :readonly="currentUserData.role != 'Club Admin'"
                          v-model="formData.long"
                          label="Long"
                          v-bind="siteCFG.fields.general"
                        >
                        </q-input>
                      </div>
                      <div class="col-12 col-md-6 q-pa-xs">
                        <q-select
                          readonly
                          v-model="formData.region"
                          label="Region"
                          :options="associationRegions"
                          v-bind="siteCFG.fields.general"
                        >
                        </q-select>
                      </div>
                      <div class="col-12 col-md-6 q-pa-xs">
                        <q-select
                          readonly
                          v-model="formData.area"
                          label="Area"
                          :options="associationAreas"
                          v-bind="siteCFG.fields.general"
                        >
                        </q-select>
                      </div>
                    </div>
                  </div>
                  <div v-if="formData.id" class="col-12 col-md-4">
                    <div class="row">
                      <div class="col-12">
                        <div
                          v-if="
                            (changeImage || !formData.capUrl) && formData.id
                          "
                          style="margin: auto; width: 300px"
                        >
                          <!-- <croppa
                            ref="imgCroppa"
                            :height="200"
                            :width="300"
                            :show-remove-button="true"
                            v-model="myCroppa"
                            remove-button-color="#68c6d2"
                            :show-loading="true"
                            :loading-size="50"
                            crossOrigin="anonymous"
                            :quality="2"
                            :prevent-white-space="false"
                            :placeholder="'Choose an image (300x200)'"
                            :placeholder-font-size="15"
                          >
                          </croppa>
                          <q-btn
                            class="full-width"
                            color="negative"
                            label="Cancel"
                            @click="
                              changeImage = false;
                              myCroppa = null;
                            "
                            v-if="formData.id && formData.capUrl"
                          >
                          </q-btn> -->
                        </div>
                        <div v-else style="margin: auto; width: 300px">
                          <q-img
                            :src="formData.capUrl"
                            style="height: 200px; width: 300px"
                            v-if="formData.id"
                          >
                          </q-img>
                          <!-- <q-btn
                            class="full-width"
                            color="primary"
                            label="Change"
                            @click="changeImage = true"
                            v-if="formData.id"
                          >
                          </q-btn> -->
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-12">
                    <h6 class="q-my-none q-mt-xs">Contact</h6>
                  </div>
                  <div class="col-12 col-md-6 q-pa-xs">
                    <q-input
                      :readonly="currentUserData.role != 'Club Admin'"
                      v-model="formData.contactName"
                      label="Contact"
                      v-bind="siteCFG.fields.general"
                    >
                      <template v-slot:prepend>
                        <q-icon name="mdi-account" />
                      </template>
                    </q-input>
                  </div>
                  <div class="col-12 col-md-6 q-pa-xs">
                    <q-input
                      :readonly="currentUserData.role != 'Club Admin'"
                      label="Email"
                      v-model="formData.contactEmail"
                      v-bind="siteCFG.fields.general"
                    >
                      <template v-slot:prepend>
                        <q-icon name="mdi-email" />
                      </template>
                    </q-input>
                  </div>
                  <div class="col-10 col-md-4 q-pa-xs">
                    <q-input
                      :readonly="currentUserData.role != 'Club Admin'"
                      v-model="formData.contactPhone"
                      label="Phone"
                      v-bind="siteCFG.fields.general"
                    >
                      <template v-slot:prepend>
                        <q-icon name="mdi-phone" />
                      </template>
                    </q-input>
                  </div>
                  <div class="col-2 col-md-12 q-pa-xs">
                    <q-input
                      :readonly="currentUserData.role != 'Club Admin'"
                      v-model="formData.contactPhoneExt"
                      label="Ext"
                      v-bind="siteCFG.fields.general"
                    >
                    </q-input>
                  </div>
                  <div class="col-12 col-md-6 q-pa-xs">
                    <q-input
                      v-model="formData.contactMobile"
                      label="Mobile"
                      :readonly="currentUserData.role != 'Club Admin'"
                      v-bind="siteCFG.fields.general"
                    >
                      <template v-slot:prepend>
                        <q-icon name="mdi-cellphone" />
                      </template>
                    </q-input>
                  </div>
                </div>
              </div>
            </div>
          </q-card-section>
          <!-- <expandedToolbar
            :newButton="true"
            @newButtonClick="newDialog = true"
          /> -->
        </q-card>
      </div>
    </div>
  </q-page>
</template>

<script>
  import { mapGetters } from "vuex";
  import datatable from "@/components/datatable/datatable.vue";
  import competitionForm from "@/components/competitions/competitionForm.vue";
  import moment from "moment";

  // import { Notify } from "quasar";

  export default {
    components: {
      datatable,
      competitionForm,
    },
    computed: {
      ...mapGetters({
        currentUser: "auth/currentUser",
        currentUserData: "auth/currentUserData",
        data: "associations/current",
        dataLoading: "competitions/listLoading",
        gridData: "competitions/list",

        siteCFG: "settings/siteCFG",
      }),
    },
    data: () => ({
      formData: null,
      id: null,

      // Croppa
      myCroppa: {},
      changeImage: false,

      // data-table
      columns: [
        {
          name: "competition_name",
          label: "Competition",
          align: "left",
          field: "competition_name",
          style:
            "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",

          sortable: true,
        },
        {
          name: "start_date",
          label: "Start Date",
          align: "left",
          field: "start_date",
          format: (val) =>
            val != null ? moment(val).format("DD-MMM, YYYY") : "",
          sortable: true,
        },
        {
          name: "entriesCloseDate",
          label: "Entries Close Date",
          align: "left",
          field: "entriesCloseDate",
          format: (val) =>
            val != null ? moment(val).format("DD-MMM, YYYY") : "",
          sortable: true,
        },
        {
          name: "actions",
          label: "Actions",
          align: "left",
          sortable: false,
        },
      ],
      search: "",

      createLoading: false,

      newDialog: false,

      // View and Edit
      viewFormData: {},
      saveLoading: false,
      viewDetailsDialog: false,
    }),
    watch: {
      data: function () {
        this.init();
      },
      // $route: function () {
      //   this.handleRoute();
      // },
    },
    mounted() {
      this.id = this.currentUserData.currentAssociation_id;
      this.init();
      this.loadData();
      // this.handleRoute();
      this.$store.dispatch("associations/loadByID", this.id);
    },
    methods: {
      init() {
        if (this.data != null && this.data.id == this.id) {
          this.formData = JSON.parse(JSON.stringify(this.data));
        } else {
          this.formData = {};
        }
      },
      loadData() {
        this.$store.dispatch("competitions/loadAll");
      },
      // handleRoute() {
      //   if (this.$route.params.id) {
      //     this.viewFormData = { id: this.$route.params.id };
      //     this.$nextTick(() => {
      //       this.viewDetailsDialog = true;
      //     });
      //   } else {
      //     this.viewDetailsDialog = false;
      //   }
      // },
      // close() {
      //   this.$router.push("/competitions");
      // },
      save() {
        this.$emit("loadingStateChanged", true);
        // if (this.myCroppa && this.myCroppa.imageSet) {
        //   this.formData.image = {
        //     dataUrl: this.myCroppa.generateDataUrl(),
        //   };
        // } else {
        //   delete this.formData.image;
        // }

        this.$store
          .dispatch("associations/save", this.formData)
          .then((result) => {
            this.$emit("loadingStateChanged", false);
            // console.log(result);
            if (result.Result == "Success") {
              this.$store.dispatch("associations/loadByID", this.id);
              this.$q.notify({
                position: "top-right",
                type: "positive",
                message: "The Association has been saved",
              });
            } else {
              this.$q.notify({
                position: "top-right",
                type: "negative",
                message: "There was an Error, Please try again later",
              });
            }
          });
      },
    },
  };
</script>

<style lang="scss" scoped>
  #depthCard:hover {
    background: #5cb3ff;
    color: white;
  }

  .formHeight {
    min-height: calc(100vh - 175px);
    max-height: 1000px;
  }
</style>
